import { useMutation } from "react-query";
import { updateFormFieldsReq } from "api";
import { useHeaders } from "hooks/api/useHeaders";

interface FormMutationProps {
    // eslint-disable-next-line
    formValues: Record<string, any>;
}

// TODO: find a better way of handling selected materials that might be undefined (but they won't be)
export const useMaterialDetailsForm = (materialSpecId = 0, materialId?: number) => {
    const headers = useHeaders();

    return useMutation(({ formValues }: FormMutationProps) => {
        /**
         * TODO: this update can be adjusted based on the actions fields initial values, which can be compared with
         * form values to avoid updating fields that didn't change
         */
        return updateFormFieldsReq(headers, formValues, materialSpecId, materialId);
    });
};
